import { DatePicker, FormCard, FormItem, TimeInput, theme } from '@lmc/ui-kit'
import { Text } from '@lmc/ui-kit/src/general'
import { Tooltip } from 'antd'
import useFeatureFlags from 'hooks/useFeatureFlags'
import type { FC } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import Asterix from '../RotaPattern/components/Asterix'
import type { ModalSectionProps } from '../RotaPattern/utils'
import { getRequiredRule } from '../utils'

type OneOffTimeWindowProps = {
  type?: 'visit' | 'shift'
  isFlexiType?: boolean
  shortTitle?: boolean
  onStartTimeChanged?: (time?: string) => void
  onEndTimeChanged?: (time?: string) => void
  disableStartTime?: boolean
  disableEndTime?: boolean
} & ModalSectionProps

const OneOffTimeWindow: FC<OneOffTimeWindowProps> = ({
  type,
  shortTitle,
  onEndTimeChanged,
  onStartTimeChanged,
  disableStartTime,
  disableEndTime,
  formData
}) => {
  const { t } = useTranslation()

  const flags = useFeatureFlags({
    flagNames: ['rostering_admin_editing_flexibility']
  })?.data

  const flagsRosteringAdminEditingFlexibility =
    flags?.rostering_admin_editing_flexibility?.enabled

  return (
    <FormCard
      level={2}
      title={
        shortTitle
          ? t('DATE_AND_TIME')
          : t('WHEN_SHOULD_THIS', { variable: type })
      }
      subtitle={
        shortTitle
          ? undefined
          : t('WHEN_SHOULD_THIS_DESCRIPTION', { variable: type })
      }
    >
      <Tooltip
        color={theme.color.neutral.color3}
        title={
          disableStartTime || disableEndTime ? (
            <ContentContainer>
              <Text>
                {flagsRosteringAdminEditingFlexibility
                  ? t('DETAIL_EDITABLE_BY_ADMIN')
                  : t('DETAIL_CANNOT_BE_EDITED')}
              </Text>
            </ContentContainer>
          ) : (
            ''
          )
        }
        open={disableStartTime || disableEndTime ? undefined : false}
        overlayInnerStyle={{ width: '450px', padding: '8px 16px' }}
      >
        <FormItem
          name="patternStart"
          label={<Text>{t('DATE')}</Text>}
          rules={[getRequiredRule(t('DATE'))]}
        >
          <DatePicker disabled={disableStartTime || disableEndTime} />
        </FormItem>
      </Tooltip>
      <FormItem
        label={
          <Text>
            {' '}
            <Asterix />
            {t('TIME_WINDOW')}
          </Text>
        }
      >
        <TimeInput
          startTime={formData?.startTime}
          onEndTimeChanged={onEndTimeChanged}
          onStartTimeChanged={onStartTimeChanged}
          disableStartTime={disableStartTime}
          disableEndTime={disableEndTime}
          disableTooltip={
            flagsRosteringAdminEditingFlexibility
              ? t('DETAIL_EDITABLE_BY_ADMIN')
              : t('DETAIL_CANNOT_BE_EDITED')
          }
        />
      </FormItem>
    </FormCard>
  )
}

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  color: ${(props) => props.theme.color.neutral.color11};
`

export default OneOffTimeWindow
